module.exports = __webpack_public_path__ + "static/media/img--320x240.98581828.98581828.webp";